import React from 'react';

import { KeyboardBackspaceIcon, CloseIcon } from '@ocx/ui-icons';
import { IconButton, IconButtonProps } from '@ocx/ui';

export type IBackButtonComponentProps = {
  onClick: () => void;
  type?: 'back' | 'close';
  sx?: IconButtonProps['sx'];
};

export const BackButtonComponent = (props: IBackButtonComponentProps) => {
  const { onClick, type = 'back', sx } = props;
  return (
    <IconButton onClick={onClick} aria-label={type} color="inherit" sx={sx}>
      {type === 'close' ? <CloseIcon /> : <KeyboardBackspaceIcon />}
    </IconButton>
  );
};
